import { Flex, Typography } from "antd";
import styled from "styled-components";
import { useTranslate } from "#src/hooks";

const StepContent = styled(Flex)`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const MobileLayout = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 28px;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;

  .voice-clone-button-solid.ant-btn-primary:disabled {
    background-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
  }
`;

export const ContentWrapper = ({
  children,
  showTitle = true,
}: {
  children: React.ReactNode;
  showTitle?: boolean;
}) => {
  const t = useTranslate();
  return (
    <Flex
      vertical
      align="center"
      gap={70}
      style={{
        width: "100%",
        flex: 1,
        minHeight: 0,
        alignSelf: "stretch",
      }}
    >
      <Typography.Title
        level={4}
        style={{
          margin: 0,
          padding: 6,
          fontWeight: 500,
          flexShrink: 0,
          opacity: showTitle ? 1 : 0, //to fix the layout shift
        }}
      >
        {t("src.components.ContactCloningMobile.title")}
      </Typography.Title>

      <StepContent
        vertical
        align="center"
        style={{ width: "100%" }}
      >
        {children}
      </StepContent>
    </Flex>
  );
};
